export const ANALYTICS_LABELS: { [key: string]: string } = {
  ActivitiesWorthNoting: 'Atividades que valem nota',
  exercise: 'Exercícios',
  trivia: 'Pensar e Responder',
  objectiveTrivia: 'Pensar e Responder Objetivo',
  practice: 'Atividade Prática',
  article: 'Material de apoio',
  video: 'Vídeo',
  revisionList: 'Lista de Revisão',
  tutoring: 'Tutoria',
  delivery: 'Entrega',
};
